import React, { useEffect } from "react";
import { connect } from "react-redux";
import "./CustomInput.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

const CustomInput = React.forwardRef((props, ref) => {
	const { formatMessage } = useIntl();

	const onChangeHandler = (e) => {
		props.onChange(e);
	};

	return (
		<div className={`${props.className ? props.className : ""} flex direction-col align-items-start`}>
			<div>
				{props.label ? (
					<label className="text text-body--4">{formatMessage({ id: `${props.label}` })}</label>
				) : (
					<></>
				)}
				{props.isMandatory ? <span className="input-mandatory-sign ml-8">*</span> : <></>}
			</div>
			<div
				className={`input-wrapper flex direction-row align-items-center mt-4 ${
					props.state ? props.state : ""
				} ${props.disabled ? "disabled" : ""}`}
				style={props.styles}
			>
				{props.icon ? <FontAwesomeIcon className="input-icon" icon={props.icon} /> : <></>}
				{props.loading ? (
					<div className="input-loader"></div>
				) : (
					<>
						{props.disabled ? (
							<div className="text text-body--3">{props.value}</div>
						) : (
							<input
								id={props.id}
								type={props.type}
								ref={ref}
								value={props.value}
								className={`icon`}
								placeholder={formatMessage({ id: `${props.placeholder}` })}
								maxLength={props.max ? props.max : ""}
								onChange={(e) => {
									onChangeHandler(e);
								}}
								style={props.styles}
							/>
						)}
					</>
				)}
			</div>
			{props.caption && <div className="text text-body--5">{formatMessage({ id: props.caption })}</div>}
		</div>
	);
});

export default CustomInput;
